<template>
  <div>
    <NewNavbar variant="account" />
    <AccountWrapper :navigation-menu-items="navigationMenuItems">
      <nuxt />
    </AccountWrapper>
    <SupportBubble :locale="locale" />
    <StickyNavigation :navigation-menu-items="navigationMenuItems" />
  </div>
</template>
<script>
import { authenticated } from '@/mixins/layouts'
import NewNavbar from '@/components/NewNavbar'
import AccountWrapper from '@/components/NewNavbar/AccountWrapper'
import SupportBubble from '@/components/SupportBubble'
import StickyNavigation from '@/components/StickyNavigation'
import { mapState } from 'vuex'

export default {
  name: 'LayoutAccount',
  middleware: 'auth',
  components: {
    SupportBubble,
    StickyNavigation,
    NewNavbar,
    AccountWrapper
  },
  mixins: [authenticated],
  computed: {
    ...mapState('app', {
      locale: state => state.locale
    })
  },
  head () {
    return {
      title: 'Account'
    }
  }
}
</script>
